import React from "react";
import { Box, Typography } from "@mui/material";
import GuidedDemo from "../InteractiveDemo/GuidedDemo";
import "../InteractiveDemo/interactiveDemo.css";

const LandingInteractiveDemoSection = () => (
  <Box className="interactive-demo-page" sx={{ bgcolor: "#EAF1ED", pb: { xs: 7, md: 10 } }}>
    <Box sx={{ pt: { xs: 7, md: 10 }, px: 2, textAlign: "center" }}>
      <Typography sx={{ color: "#477765", fontSize: "0.75rem", fontWeight: 800, letterSpacing: "0.12em", textTransform: "uppercase" }}>
        See Lifelog in action
      </Typography>
      <Typography component="h2" sx={{ mt: 1.2, mx: "auto", maxWidth: 780, color: "#24342F", fontFamily: "'Fraunces', Georgia, serif", fontSize: { xs: "2.25rem", md: "3.5rem" }, fontWeight: 700, lineHeight: 1.06, letterSpacing: "-0.04em" }}>
        Take a small look around.
      </Typography>
      <Typography sx={{ mt: 1.5, color: "#687972", fontSize: { xs: "0.95rem", md: "1.05rem" } }}>
        Try a note with Maya’s fictional story, then see where it goes. No account needed.
      </Typography>
    </Box>

    <GuidedDemo id="landing-interactive-demo" />

  </Box>
);

export default LandingInteractiveDemoSection;
